import {Construtor} from './construtor';

export class AcompanhamentoAlcada implements Construtor<AcompanhamentoAlcada> {

  public numeroAlcada: number;
  public nomeUsuario: string;
  public horasAlcada: number;
  public horasConfig: number;
  public dataAlteracao: Date;

  constructor(object?: any) {
    if (object !== undefined && object !== null) {

      if (object instanceof AcompanhamentoAlcada) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }

    return this;
  }

  copyObject(acompanhamento: AcompanhamentoAlcada): void {
    this.numeroAlcada = acompanhamento.numeroAlcada;
    this.nomeUsuario = acompanhamento.nomeUsuario;
    this.horasAlcada = acompanhamento.horasAlcada;
    this.horasConfig = acompanhamento.horasConfig;
    this.dataAlteracao = acompanhamento.dataAlteracao;
  }

  parseFromJson(acompanhamento: any): void {
    this.numeroAlcada = acompanhamento.numeroAlcada;
    this.nomeUsuario = acompanhamento.nomeUsuario;
    this.horasAlcada = acompanhamento.horasAlcada;
    this.horasConfig = acompanhamento.horasConfig;
    this.dataAlteracao = acompanhamento.dataAlteracao;
  }

  modeloCompleto(): boolean {
    return this.numeroAlcada !== undefined;
  }

  getNewInstance(object?: any): AcompanhamentoAlcada {
    return new AcompanhamentoAlcada(object);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/acompanhamento-alcada.ts